import React from 'react';
import { Page } from 'ui/components';
import Nav from './component/nav';

const DetailLayout = ({ customer_id, loading, action, children }) => {
  return (
    <Page className="col-md-8 col-12 bordered">
      <Page.Header
        title="Detail Customer"
        isLoading={loading}
        className="bg-light"
      >
        {action}
      </Page.Header>

      <Page.Body className="row border-top mt-3 mt-md-0 h-100 bg-white">
        <div className="col-3 ps-0 pe-0">
          <Nav id={customer_id} />
        </div>
        <div className="col-9 p-0 ">{children}</div>
      </Page.Body>
    </Page>
  );
};

export default DetailLayout;
